import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | failed | timeout
  const [info, setInfo] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("failed"); return; }
    let timer;
    const poll = async () => {
      if (attempts.current >= 8) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        setInfo(res.data);
        if (res.data.payment_status === "paid") { setState("paid"); return; }
        if (res.data.status === "failed") { setState("failed"); return; }
      } catch (e) {}
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-success-page">
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8 text-center">
        {state === "checking" && (
          <>
            <Loader2 className="h-12 w-12 text-primary animate-spin mx-auto" />
            <h1 className="font-display text-xl font-bold mt-4">Mengesahkan pembayaran...</h1>
            <p className="text-muted-foreground text-sm mt-2">Sila tunggu sebentar.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
              <CheckCircle2 className="h-9 w-9 text-emerald-600" />
            </div>
            <h1 className="font-display text-2xl font-bold mt-4" data-testid="payment-success-title">Pembayaran Berjaya! 🎉</h1>
            <p className="text-muted-foreground text-sm mt-2">
              Pelan <span className="font-semibold text-foreground">{info?.plan}</span> anda kini aktif.
            </p>
            <Button onClick={() => navigate("/app")} data-testid="payment-success-continue" className="mt-6 rounded-full w-full">
              Ke Dashboard <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </>
        )}
        {(state === "failed" || state === "timeout") && (
          <>
            <div className="h-16 w-16 rounded-full bg-rose-100 flex items-center justify-center mx-auto">
              <XCircle className="h-9 w-9 text-rose-600" />
            </div>
            <h1 className="font-display text-xl font-bold mt-4">{state === "timeout" ? "Masih diproses" : "Pembayaran gagal"}</h1>
            <p className="text-muted-foreground text-sm mt-2">
              {state === "timeout" ? "Pembayaran mengambil masa lebih lama. Semak semula sebentar lagi." : "Tiada bayaran dibuat."}
            </p>
            <Button onClick={() => navigate("/app/billing")} variant="outline" className="mt-6 rounded-full w-full">Kembali ke Langganan</Button>
          </>
        )}
      </div>
    </div>
  );
}
